// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1jocE","inner":"Form_inner__20sOt","range":"Form_range__3GT1l","name":"Form_name__1J4wG","actions":"Form_actions__S9ra_"};